import { Component, input } from '@angular/core';

import { SpinnerComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-uploading-attachments-item',
  templateUrl: './uploading-attachments-item.component.html',
  styleUrls: ['./uploading-attachments-item.component.less'],
  imports: [SpinnerComponent],
})
export class UploadingAttachmentsItemComponent {
  public readonly fileData = input<{
    file: File;
  }>(undefined!);
}
